import { render, staticRenderFns } from "./ajFormEdit.vue?vue&type=template&id=5f7ef923"
import script from "./ajFormEdit.vue?vue&type=script&lang=js"
export * from "./ajFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports